import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../../components/Utils/CallApi";
import { setPageLoadingTrue, setPageLoadingFalse } from "../appSlice";
import { setError } from "../appSlice";

export const fetchSubscribers = createAsyncThunk(
  "subscribers/fetchSubscribers",
  async ({ companyId, page, limit }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = `companyId=${companyId}&sectionType=subscribers&page=${page}&limit=${limit}`;
      const response = await get("sections/data/list", params);

      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const saveSubscriber = createAsyncThunk(
  "subscribers/saveSubscriber",
  async ({ payload, sectionId }, { dispatch, getState, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const state = getState();
      const response = await post(
        "sections/data/save",
        payload,
        state.app,
        sectionId
      );

      if (response.status === "failure") {
        return rejectWithValue(response.result);
      }

      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);
const subscribersSlice = createSlice({
  name: "subscribers",
  initialState: {
    subscribersList: [],
    loading: false,
    error: null,
  },
  reducers: {
    addSubscriber: (state, action) => {
      state.subscribersList.push(action.payload);
    },
    editSubscriber: (state, action) => {
      const index = state.subscribersList.findIndex(
        (subscriber) => subscriber.id === action.payload.id
      );
      if (index !== -1) {
        state.subscribersList[index] = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch subscribers
      .addCase(fetchSubscribers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubscribers.fulfilled, (state, action) => {
        state.loading = false;
        state.subscribersList = action.payload; // Replace entire list with new data
      })
      .addCase(fetchSubscribers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Save subscriber
      .addCase(saveSubscriber.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveSubscriber.fulfilled, (state, action) => {
        state.loading = false;
        // Replace the subscriber list with the updated data
        state.subscribersList = action.payload; // Replace the full list
      })
      .addCase(saveSubscriber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { addSubscriber, editSubscriber } = subscribersSlice.actions;
export default subscribersSlice.reducer;
